import data from "../../shared/sharedData";

export default {
  name: "Attorney or Agent Information (if applicable)",
  prefix: "E",
  sections: [
    {
      name: "Type of Representation",
      fields: [
        {
          isGroup: {
            code: "D.1",
            machine_name: "d1_agent_type_id",
            label:
              "Indicate the type of representation for the employer in the filing of this application.",
            tooltip:
              "Identify whether the employer is represented by an attorney or agent in the filing of this application. Only mark one box. If you mark “Attorney” or “Agent,” complete the remainder of Section D. If you mark “None,” in question 1, skip questions 2 to 20 and continue to Section E.",
            coloring: "none",
            fields: [
              {
                widget: "radio",
                choice: "Attorney",
                value: "Attorney",
                validate: ["required"],
                clearFiles: ["d20_agent_agreement_attached"],
              },
              {
                widget: "radio",
                choice: "Agent",
                value: "Agent",
                validate: ["required"],
                clearSchema: [
                  "d17_agent_bar_number",
                  "d18_agent_court_state_id",
                  "d19_agent_court_name",
                ],
              },
              {
                widget: "radio",
                choice: "None",
                value: "None",
                validate: ["required"],
                clearSchema: [
                  "d1_agent_type_id",
                  "d2_agent_last",
                  "d3_agent_first",
                  "d4_agent_middle",
                  "d5_agent_address_1",
                  "d6_agent_address_2",
                  "d7_agent_city",
                  "d8_agent_state_id",
                  "d9_agent_zip",
                  "d10_agent_country_id",
                  "d11_agent_province",
                  "d12_agent_phone",
                  "d13_agent_phone_ext",
                  "d14_agent_email",
                  "d15_agent_firm_name",
                  "d16_agent_firm_fein",
                  "d17_agent_bar_number",
                  "d18_agent_court_state_id",
                  "d19_agent_court_name",
                  "d20_agent_agreement_attached",
                ],
                clearFiles: ["d20_agent_agreement_attached"],
              },
            ],
          },
        },
      ],
    },
    {
      isVisible: {
        when: "d1_agent_type_id",
        is: ["Attorney", "Agent"],
        operator: "||",
      },
      name: "Attorney / Agent Name",
      fields: [
        {
          code: "D.2",
          machine_name: "d2_agent_last",
          widget: "text",
          label: "Attorney or Agent's Last (family) Name",
          validate: [
            "required",
            // {
            //   minLength: 2,
            //   message: "Attorney or Agent's Last Name must contain at least 2 characters.",
            // },
          ],
          warning: {
            text: "In accordance with OMB approved instructions, the attorney/agent information contained in this section, specifically the name, telephone number, and email address, must be different from the employer's point of contact information in Section C of this application, unless the person named in this section is an employee of the employer.",
            isVisible: {
              when: "c1_poc_last",
              is: "d2_agent_last",
              operator: "compareFieldValues",
            },
          },
          maxLength: 35,
          tooltip: "Enter the last (family) name of the attorney/agent.",
        },
        {
          code: "D.3",
          machine_name: "d3_agent_first",
          widget: "text",
          label: "First (given) Name",
          validate: ["required"],
          maxLength: 35,
          warning: {
            text: "Please verify the information entered for accuracy. In accordance with OMB approved instructions, the attorney/agent information contained in this section, specifically the name, telephone number, and email address, must be different from the employer's point of contact information in Section C of this application, unless the person named in this section is an employee of the employer.",
            isVisible: {
              when: "d2_agent_last d3_agent_first",
              is: ["c1_poc_last", "c2_poc_first"],
              operator: "compareMultiFieldValues",
            },
          },
          tooltip: "Enter the first (given) name of the attorney/agent.",
        },
        {
          code: "D.4",
          machine_name: "d4_agent_middle",
          widget: "text",
          label: "Middle name(s)",
          maxLength: 35,
          tooltip: "Enter the middle name of the attorney/agent.",
        },
      ],
    },
    {
      isVisible: {
        when: "d1_agent_type_id",
        is: ["Attorney", "Agent"],
        operator: "||",
      },
      name: "Attorney / Agent Address",
      fields: [
        {
          code: "D.5",
          machine_name: "d5_agent_address_1",
          widget: "text",
          label: "Address 1",
          validate: [
            "required",
            {
              minLength: 2,
              message: "Please enter full street address.",
            },
          ],
          maxLength: 60,
          tooltip: "Enter the street address of the attorney/agent.",
        },
        {
          code: "D.6",
          machine_name: "d6_agent_address_2",
          widget: "text",
          label:
            "<span>Address 2 <i>(apartment/suite/floor and number)</i></span>",
          maxLength: 60,
          tooltip:
            "If additional space is needed for the street address, use this line to complete the attorney/agent’s street address.",
        },
        {
          code: "D.10",
          machine_name: "d10_agent_country_id",
          widget: "select",
          label: "Country",
          selection: data.country,
          clearSchema: ["d8_agent_state_id", "d11_agent_province"],
          validate: ["required"],
          tooltip:
            "Enter the country of the attorney/agent. If the city and country are the same, the name <u>must</u> still be entered in <u>both</u> fields.",
        },
        {
          code: "D.7",
          machine_name: "d7_agent_city",
          widget: "text",
          label: "City",
          disabled: true,
          disableWhenField: "d10_agent_country_id",
          validate: [
            "required",
            {
              minLength: 2,
              message: "Please enter full City.",
            },
          ],
          maxLength: 35,
          tooltip:
            "Enter the city of the attorney/agent. If the city and country are the same, the name <u>must</u> still be entered in <u>both</u> fields.",
        },
        {
          code: "D.8",
          machine_name: "d8_agent_state_id",
          widget: "select",
          label: "State",
          state: true,
          disabled: true,
          disableWhenField: "d10_agent_country_id",
          selection: data.state,
          validate: ["required"],
          isVisible: {
            when: "d10_agent_country_id",
            is: ["UNITED STATES OF AMERICA", "- Select -", ""],
            operator: "||",
          },
          tooltip: "Enter the state of the attorney/agent.",
        },
        {
          code: "D.9",
          machine_name: "d9_agent_zip",
          widget: "text",
          label: "Postal Code",
          disabled: true,
          disableWhenField: "d10_agent_country_id",
          validate: [
            "required",
            {
              postalCountry: "d10_agent_country_id",
              needsFieldValues: true,
              extraData: {
                valueOf: "d10_agent_country_id",
              },
            },
            {
              isRequired: "d10_agent_country_id",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "UNITED STATES OF AMERICA",
              },
            },
          ],
          maxLength: 10,
          tooltip: "Enter the postal (zip) code of the attorney/agent.",
        },
        {
          code: "D.11",
          machine_name: "d11_agent_province",
          widget: "text",
          label: "Province",
          disabled: true,
          disableWhenField: "d10_agent_country_id",
          maxLength: 25,
          validate: [
            {
              isRequired: "d10_agent_country_id",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "CANADA",
              },
            },
            {
              minLength: 5,
              message: "Province must contain at least 5 characters.",
            },
          ],
          tooltip: "Enter the province of the attorney/agent, if applicable.",
        },
      ],
    },
    {
      isVisible: {
        when: "d1_agent_type_id",
        is: ["Attorney", "Agent"],
        operator: "||",
      },
      name: "Attorney / Agent Contact Information",
      fields: [
        {
          code: "D.12",
          machine_name: "d12_agent_phone",
          widget: "phone",
          label: "Telephone Number",
          validate: ["required", "phone"],
          warning: {
            text: "Please verify the information entered for accuracy. In accordance with OMB approved instructions, the attorney/agent information contained in this section, specifically the name, telephone number, and email address, must be different from the employer's point of contact information in Section C of this application, unless the person named in this section is an employee of the employer.",
            isVisible: {
              when: "c12_poc_phone",
              is: "d12_agent_phone",
              operator: "compareFieldValues",
            },
          },
          tooltip:
            "Enter the area code and telephone number of the attorney/agent. Include country code, if applicable.",
        },
        {
          code: "D.13",
          machine_name: "d13_agent_phone_ext",
          widget: "text",
          label: "Extension",
          validate: ["number"],
          parse: "positiveWholeNumber", //don't allow decimal Number and negative number
          maxLength: 4,
          tooltip:
            "Enter the extension of the telephone number of the attorney/agent, if applicable.",
        },
        {
          code: "D.14",
          machine_name: "d14_agent_email",
          widget: "text",
          label: "Law Firm/Business Email Address",
          validate: [
            "required",
            {
              email: {
                extraData: {
                  allowNAs: false,
                },
              },
            },
            {
              maxLength: 55,
              message: "This field cannot be more than 55 characters long.",
            },
          ],
          maxLength: 55,
          warning: {
            text: "Please verify the information entered for accuracy. In accordance with OMB approved instructions, the attorney/agent information contained in this section, specifically the name, telephone number, and email address, must be different from the employer's point of contact information in Section C of this application, unless the person named in this section is an employee of the employer.",
            isVisible: {
              when: "c14_poc_email",
              is: "d14_agent_email",
              operator: "compareFieldValues",
            },
          },
          tooltip:
            "Enter the email address of the attorney/agent in the format <a>name@emailaddress.top-level domain</a>.",
        },
      ],
    },
    {
      isVisible: {
        when: "d1_agent_type_id",
        is: ["Attorney", "Agent"],
        operator: "||",
      },
      name: "Attorney / Agent Identifiers",
      fields: [
        {
          code: "D.15",
          machine_name: "d15_agent_firm_name",
          widget: "text",
          label: "Law Firm/Business Name",
          validate: [
            "required",
            { minLength: 5, message: "Enter the full legal business name" },
          ],
          maxLength: 120,
          tooltip: "Enter the attorney/agent’s law firm or business name.",
        },
        {
          code: "D.16",
          machine_name: "d16_agent_firm_fein",
          widget: "text",
          label: "Law Firm/Business FEIN",
          validate: ["required", "fein", { minLength: 10 }],
          parse: "fein",
          maxLength: 10,
          tooltip:
            "Enter the attorney/agent's law firm or business nine-digit FEIN assigned by the IRS.",
        },
        {
          code: "D.17",
          machine_name: "d17_agent_bar_number",
          widget: "text",
          label: "State Bar Number(s)",
          // validate: ["required", { minLength: 2 }],
          isVisible: {
            when: "d1_agent_type_id",
            is: "Attorney",
          },
          maxLength: 35,
          tooltip:
            "Enter the attorney's state bar identification number.  If the attorney is licensed in more than one state, enter only one state bar identification number.  If submitting this form electronically and the attorney is licensed in a state where the bar association does not issue identification numbers, leave the field blank and once confirmed it will be automatically pre-populated with “N/A.”",
        },
        {
          code: "D.18",
          machine_name: "d18_agent_court_state_id",
          widget: "select",
          label: "State of highest court where attorney is in good standing",
          isVisible: {
            when: "d1_agent_type_id",
            is: "Attorney",
          },
          selection: data.state,
          state: true,
          validate: ["required"],
          tooltip:
            "Enter the <u>state</u> of the highest state court where the attorney is in good standing.",
        },
        {
          code: "D.19",
          machine_name: "d19_agent_court_name",
          widget: "text",
          label:
            "Name of highest state court where attorney is in good standing",
          isVisible: {
            when: "d1_agent_type_id",
            is: "Attorney",
          },
          validate: ["required"],
          maxLength: 55,
          tooltip:
            "Enter the <u>name</u> of the highest state court where the attorney is in good standing.",
        },
      ],
    },
    {
      isVisible: {
        when: "d1_agent_type_id",
        is: "Agent",
      },
      name: "Document Upload - Agent Agreement",
      fields: [
        {
          code: "D.20",
          machine_name: "d20_agent_agreement_attached",
          label:
            "A copy of the current agreement or other documentation demonstrating the agent's authority to represent the employer is attached to this application.<br><br>Only .pdf, .doc, .docx, .txt, .xls, .xlsx files under 30 MB can be uploaded.",
          tooltip:
            "H-2A Only: For master applications filed on behalf of more than one employer, in the form Select the Additional Employer button to add each additional employer by legal business name, mailing address, and the total worker positions as needed for that employer. H-2B: Enter the full legal name of the business, person, association, firm, corporation, or organization, i.e., the employer filing this application. The employer's full legal name is the exact name of the individual, corporation, LLC, partnership, or other organization that is reported to the Internal Revenue Service.",

          name: "Agent Agreement",
          widget: "file_upload",
          fileTypes: [".pdf", ".doc", ".docx", ".txt", ".xls", ".xlsx"],
          validate: ["required", "checkValue"],
        },
      ],
    },
  ],
};
